import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { LoadingPageContainer } from "./styles";
import { IconTakeatFilled } from "../icons";
export var LoadingPage = forwardRef(function LoadingPage(_a, ref) {
    var customColor = _a.customColor, _b = _a.text, text = _b === void 0 ? "Carregando..." : _b, reversed = _a.reversed, props = __rest(_a, ["customColor", "text", "reversed"]);
    return (_jsxs(LoadingPageContainer, __assign({ ref: ref, customColor: customColor, reversed: reversed }, props, { children: [_jsx(IconTakeatFilled, { fontSize: 125 }), _jsx("span", { children: text })] })));
});
//# sourceMappingURL=index.js.map